// extracted by mini-css-extract-plugin
export default {"page":"li-z","cartModal":"mi-z","checkout":"ni-z","placeholder":"oi-z","account":"pi-z"};